import { render, staticRenderFns } from "./ReceiverOrderInfoSummary.vue?vue&type=template&id=3f77010d&"
import script from "./ReceiverOrderInfoSummary.vue?vue&type=script&lang=js&"
export * from "./ReceiverOrderInfoSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReceiverOrderInfoSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports